// DetailHeader.js
import React from 'react';
import { Box, Button, Typography, useMediaQuery, useTheme } from '@mui/material';
import { Link } from 'react-router-dom';
import * as Icons from '@mui/icons-material';

function DetailHeader({ title, actions, backLink, backLabel }) {
  const theme = useTheme();
  const isMobile = useMediaQuery(theme.breakpoints.down('sm'));

  return (
    <Box sx={{ 
      display: 'flex', 
      flexDirection: isMobile ? 'column' : 'row',
      justifyContent: 'space-between', 
      alignItems: isMobile ? 'flex-start' : 'center', 
      gap: isMobile ? 1 : 0,
      mb: 1,
      position: 'sticky',
      top: 0,
      left: 0,
      right: 0,
      zIndex: 10,
      backgroundColor: theme.palette.background.default,
      pt: 1,
      pb: 1,
      px: isMobile ? 0 : 1,
      borderBottom: `1px solid ${theme.palette.divider}`,
      width: '100%',
      marginTop: -1,
      paddingTop: isMobile ? 2 : 1.5
    }}>
      <Button
        component={Link}
        to={backLink || '/'}
        startIcon={<Icons.ArrowBack />}
        color="primary"
        size="small"
        sx={{ alignSelf: isMobile ? 'flex-start' : 'center' }}
      >
        {backLabel || 'Back'}
      </Button>
      
      <Typography 
        variant={isMobile ? "h6" : "h5"} 
        sx={{ 
          fontWeight: 600,
          fontSize: { xs: '1.1rem', sm: '1.5rem' },
          lineHeight: { xs: 1.3, sm: 1.5 },
          maxWidth: '100%',
          wordWrap: 'break-word',
          textAlign: 'left',
          alignSelf: isMobile ? 'flex-start' : 'center',
          margin: isMobile ? '0 0 0.5rem 0' : 0,
          flex: 1,
          paddingLeft: isMobile ? 0 : 2,
          paddingRight: isMobile ? 0 : 2
        }}
      >
        {title}
      </Typography>
      
      <Box sx={{ 
        alignSelf: isMobile ? 'flex-end' : 'center',
        position: isMobile ? 'absolute' : 'static',
        top: isMobile ? '0.5rem' : 'auto',
        right: isMobile ? '0.5rem' : 'auto'
      }}>
        {actions}
      </Box>
    </Box>
  );
}

export default DetailHeader;